export enum ChangeRequestType {
  Change = 1,
  Cancel = 2,
  MovePackage = 3,
  MoveDeliverable = 4,
  MoveSubFunction = 5,
  PublishUnderChangeControl = 6,
}
